class JobsListing {

  constructor(feed) {
    this.form    = document.querySelector('#job-listing-filters-form');
    this.feed    = feed;
    this.post_id = this.feed.getAttribute('data-post-id');
    this.resetButton = document.querySelector('[data-clear-selection]');

    if (!this.form || !this.feed) return;
    this.bindEvents();
    this.checkFilters();
  }

  bindEvents() {

    //Form change 
    this.form.addEventListener('change', (e) => {
      if (e.target.matches('input[name="venue[]"], input[name="department[]"]')) {
        this.fetchAndRender();
      }
    });

    //Reset button
    if (this.resetButton) {

      this.resetButton.addEventListener('click', (e) => {
        e.preventDefault();
        history.replaceState({}, '', window.location.pathname);

        // Uncheck all checkboxes
        this.uncheckAllCheckboxes();

        this.resetButton.setAttribute('hidden', '');
        this.fetchAndRender();
      });

    }

  }

  uncheckAllCheckboxes() {
    const checkboxes = this.form.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(checkbox => {
      checkbox.checked = false;
    });
  }

  fetchAndRender() {

    const data = new FormData(this.form);
    const url = `${ajax_client.ajax_url}?action=jobs_feed&ajax=true&post_id=${this.post_id}`;

    this.feed.classList.add('is-loading');

    fetch(url, {
      method: 'POST',
      body: data
    })
    .then(response => response.text())
    .then(html => {
      this.feed.classList.remove('is-loading');

      //Get cards
      const parser = new DOMParser();
      const doc    = parser.parseFromString(html, 'text/html');

      const newCards = Array.from(doc.querySelectorAll('article'));
      this.feed.innerHTML = '';
      newCards.forEach(card => this.feed.appendChild(card));

      //Remove GET from URL 
      history.replaceState({}, '', window.location.pathname);

      //Set reset button
      this.checkFilters();

    })
    .catch(err => {
      this.feed.classList.remove('is-loading');
      console.error('Jobs AJAX failed:', err);
    });
  }

  checkFilters() {
  
      const checkboxes = this.form.querySelectorAll('input[type="checkbox"]');
    
      const anyChecked = Array.from(checkboxes).some(checkbox => checkbox.checked);
    
      if (anyChecked) {
        this.resetButton.removeAttribute('hidden');
      } else {
        this.resetButton.setAttribute('hidden', '');
      }
  }


}

document.addEventListener('DOMContentLoaded', () => {

  const feed = document.querySelector(".section--feed--jobs");
  
   if (feed) {
        new JobsListing(feed);
    }
});
